<template>
  <div class="engineeringApplication-wrap" :style="{backgroundColor: bgcolor}">
    <div class="engineeringApplication-inner">
    <template>
      <!-- <button class="pr-btn dark-btn" @click="goDetail">了解更多</button> -->
      <VideosBlock title="PBSD 工程应用" subTitle="Engineering Application of PBSD" :videos="engineeringApplicationVideos"/>
      <!-- bgcolor="#ebf0fa"  -->
      <!-- <VideosBlock title="入门教程" subTitle="Introductory tutorial"/>
      <VideosBlock title="进阶教程" subTitle="Advanced tutorial" bgcolor="#ebf0fa"/> -->
      
    </template>
    </div>
  </div>
  
</template>
<script>

import VideosBlock from '@/components/VideosBlock.vue'
import { engineeringApplicationVideos } from '@/config/types.config'

export default {
    props: {
    bgcolor: {
      type: String,
      default: '#ffffff'
    },
  },
  components: {
    VideosBlock
  },
  data() {
    return {
      activeTab: 'video',
      engineeringApplicationVideos
    }
  },
  methods: {
    handleClickTab(item) {
      this.activeTab = item
    },
    goDetail() {
      this.$router.push('detail')
    }
  }
}
</script>


<style lang="less" scoped>
@import url('../css/animation');
.engineeringApplication-wrap {
  position: relative;
  .engineeringApplication-inner {
    max-width: 1024px;
    margin: 0 auto;
    text-align: center;
    padding: 0px;
  }
  h2 {
    font-size: 30px;
    // font-weight: 600;
    color: #000;
    line-height: 42px;
    margin-bottom: 4px;
    margin-top: 8px;
  }
  h3 {
    font-size: 19px;
    // font-weight: 600;
    color: #000;
    line-height: 26px;
    margin-bottom: 10px;
  }
  .dark-btn {
    padding: 7px 40px;
    font-size: 20px;
    font-weight: 600;
  }
}
</style>

